import { render, staticRenderFns } from "./DialogFinalize.vue?vue&type=template&id=45807826&scoped=true"
import script from "./DialogFinalize.vue?vue&type=script&lang=js"
export * from "./DialogFinalize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45807826",
  null
  
)

export default component.exports